import React from 'react';
import client from '../api/client';

export default function BadgePreviewModal({ participantId, previewUrl, title, onClose }) {
  if (!participantId && !previewUrl) return null;
  const token = localStorage.getItem('accred_token');
  const cacheBust = Date.now();
  const src = previewUrl
    ? `${previewUrl}${previewUrl.includes('?') ? '&' : '?'}token=${token}&_t=${cacheBust}`
    : `${client.defaults.baseURL}/badges/${participantId}/pdf?token=${token}&_t=${cacheBust}`;

  return (
    <div
      style={{ position: 'fixed', inset: 0, background: 'rgba(15,22,38,0.65)', zIndex: 200, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20 }}
      onClick={onClose}
    >
      <div className="card" style={{ width: 420, maxWidth: '95vw', height: '85vh', padding: 0, display: 'flex', flexDirection: 'column' }} onClick={e => e.stopPropagation()}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '12px 16px', borderBottom: '1px solid var(--line)' }}>
          <b style={{ fontSize: 14 }}>{title || 'معاينة البطاقة'}</b>
          <div style={{ display: 'flex', gap: 8 }}>
            <a href={src} target="_blank" rel="noreferrer" className="btn btn-outline">فتح في نافذة جديدة</a>
            <button className="btn btn-outline" onClick={onClose}>إغلاق</button>
          </div>
        </div>
        <iframe title="badge-preview" src={src} style={{ flex: 1, border: 'none', width: '100%' }} />
      </div>
    </div>
  );
}
